// Versión: 7.0.6 - Parche ResizeObserver (Plan 489)
import React from "react";
import ReactDOM from "react-dom";
import CssBaseline from "@material-ui/core/CssBaseline";
import * as serviceworker from './serviceWorker'

import App from "./App";

if (typeof window !== "undefined") {
	// [ANTIGRAVITY] Parche definitivo para ResizeObserver
	const _ResizeObserver = window.ResizeObserver;
	window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
		constructor(callback) {
			super((entries, observer) => {
				window.requestAnimationFrame(() => {
					callback(entries, observer);
				});
			});
		}
	};
}

ReactDOM.render(
	<App />,
	document.getElementById("root"),
	() => {
		window.finishProgress();
	}
);

serviceworker.register()
